import { EXCHANGE_API_URL_PREFIXES, EXCHANGE_TYPES } from 'src/ducks/consts'
import { PERMISSIONS, hasPermissionTo } from 'src/utils/permissions'

const EXCHANGE_PERMISSION_SEGMENTS = {
  [EXCHANGE_TYPES.EXPORT]: 'export',
  [EXCHANGE_API_URL_PREFIXES.EXPORT]: 'export',
  [EXCHANGE_TYPES.IMPORT]: 'import',
  [EXCHANGE_API_URL_PREFIXES.IMPORT]: 'import',
  [EXCHANGE_TYPES.GENERAL]: 'general-cargo',
  [EXCHANGE_API_URL_PREFIXES.GENERAL]: 'general-cargo',
  'general-cargo': 'general-cargo',
  [EXCHANGE_TYPES.POST_IMPORT_CONTAINERS]: 'post-import',
  [EXCHANGE_API_URL_PREFIXES.POST_IMPORT_CONTAINERS]: 'post-import',
  'post-import': 'post-import',
  [EXCHANGE_TYPES.FREE_CARRIERS]: 'free-carriers',
  [EXCHANGE_API_URL_PREFIXES.FREE_CARRIERS]: 'free-carriers',
  'free-carriers': 'free-carriers',
  [EXCHANGE_TYPES.CONTRACTS]: 'contracts',
  [EXCHANGE_API_URL_PREFIXES.CONTRACTS]: 'contracts',
  contracts: 'contracts'
}

const GLOBAL_OFFER_VIEW_PERMISSION_MAP = {
  public: PERMISSIONS.STOCK_PUBLIC_OFFERS_VIEW,
  private: PERMISSIONS.STOCK_PRIVATE_OFFERS_VIEW
}

const GLOBAL_OFFER_ADD_PERMISSION_MAP = {
  public: PERMISSIONS.STOCK_PUBLIC_ADD_OFFER,
  private: PERMISSIONS.STOCK_PRIVATE_ADD_OFFER
}

const hasAnyPermissionTo = (paths, permissions) =>
  paths.some(path => path && hasPermissionTo(path, permissions))

const getExchangePermissionSegment = exchange =>
  EXCHANGE_PERMISSION_SEGMENTS[exchange] || null

export const canViewOffers = (exchange, permissions, visibility = null) => {
  const exchangePermissionSegment = getExchangePermissionSegment(exchange)

  if (!exchangePermissionSegment) {
    return false
  }

  if (!visibility) {
    return hasPermissionTo(
      `exchange.${exchangePermissionSegment}.offers.view`,
      permissions
    )
  }

  return hasAnyPermissionTo(
    [
      `exchange.${exchangePermissionSegment}.offers.${visibility}.view`,
      GLOBAL_OFFER_VIEW_PERMISSION_MAP[visibility]
    ],
    permissions
  )
}

export const canAddOffer = (exchange, permissions, visibility = null) => {
  const exchangePermissionSegment = getExchangePermissionSegment(exchange)

  if (!exchangePermissionSegment) {
    return false
  }

  if (!visibility) {
    return hasPermissionTo(
      `exchange.${exchangePermissionSegment}.offer.add`,
      permissions
    )
  }

  return hasAnyPermissionTo(
    [
      `exchange.${exchangePermissionSegment}.offer.${visibility}.add`,
      GLOBAL_OFFER_ADD_PERMISSION_MAP[visibility]
    ],
    permissions
  )
}
